import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';
import useAxios from '../../../hooks/useAxios';
import { useEffect, useState } from 'react';
import DailyMissionDetailModal from './modals/DailyMissionDetailModal';
import { IDailyMissionSummaryClass, IGetDailyMissionSummaryClass } from '../../../models/canbot.model';
import { getDailyMissionSummaryClass } from '../../../api/canbot.api';

const Block = styled.div`
  .table-link-underline {
    color: #666 !important;
    text-decoration: underline !important;
    cursor: pointer;
  }

  .weekTab:hover {
    cursor: pointer;
  }
`;

interface IProps {
  classCode: string;
}

const DailyMission = ({classCode} : IProps) => {

  const { t, i18n } = useTranslation();
  const { chosenClass } = useSelector((state: RootState) => state.class);
  const { data: res, isLoading, error, execute } = useAxios<IGetDailyMissionSummaryClass>();

  const [selectedWeek, setSelectedWeek] = useState(0);
  const [selectedData, setSelectedData] = useState<IDailyMissionSummaryClass>();
  const [summaryData, setSummaryData] = useState<IDailyMissionSummaryClass[]>([]);
  const [detailModalVisible, setDetailModalVisible] = useState(false);

  const weeks = [
    {weekSeq: 0, weekName: t('common.text.all')},
    ...Array.from({ length: 12 }, (_, i) => ({weekSeq: i + 1, weekName: `Week ${i + 1}`})),
  ];

  useEffect(() => {
    execute(getDailyMissionSummaryClass(classCode, selectedWeek));
  }, [classCode, selectedWeek]);

  useEffect(() => {
    if (res && res.data) {
      setSummaryData(res.data); // 배열로 저장
    }
  }, [res]);

  const handleDetailClick = (data: IDailyMissionSummaryClass) => {
    setSelectedData(data);
    setDetailModalVisible(true);
  };

  return (
    <Block>
      <div className="comm-bx__between"><h3 className="sub-title">{chosenClass?.className}</h3></div>
      <div className="comm-tab__line">
        <ul>
          {weeks.map((week) => (
            <li
              key={week.weekSeq}
              className={selectedWeek === week.weekSeq ? 'active weekTab' : 'weekTab'}
              onClick={() => setSelectedWeek(week.weekSeq)}
            >
              <span className="btn-item">{week.weekName}</span>
            </li>
          ))}
        </ul>
      </div>
      <div className="comm-table__area">
        <table>
          <colgroup>
            <col width="3.23%" />
            <col width="21.93%" />
            <col width="18.71%" />
            <col width="18.71%" />
            <col width="18.71%" />
            <col width="18.71%" />
          </colgroup>
          <thead>
            <tr>
              <th className="text-center">No</th>
              <th className="text-center">Name</th>
              <th className="text-center">{t('class.canbot.label2')}</th>
              <th className="text-center">{t('class.canbot.label3')}</th>
              <th className="text-center">{t('class.canbot.label4')}</th>
              <th className="text-center">{t('class.canbot.label5')}</th>
            </tr>
          </thead>
          <tbody>
            {summaryData.map((data, idx) => (
              <tr key={idx}>
                <td className="text-center">{idx + 1}</td>
                <td className="text-center">{data.memberName}</td>
                <td className="text-center">{data.missionCount}</td>
                <td className="text-center">{data.passCount}</td>
                <td className="text-center">{data.profanityCount}</td>
                <td className="text-center">
                  {data.missionCount > 0 ? (<span className="table-link-underline" onClick={() => handleDetailClick(data)}>{t('common.button.confirm')}</span>) : ''}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {detailModalVisible && (
        <DailyMissionDetailModal
          visible={detailModalVisible}
          setVisible={setDetailModalVisible}
          classCode={chosenClass?.classCode || ''}
          weekSeq={selectedWeek}
          summaryData={selectedData}
        />
      )}
    </Block>
  );
};

export default DailyMission;